<div class="footer pt-3">
  <div class="footer-container d-flex flex-column">
    <div class="container">
      <iframe width="100%" height="165px" src="https://www.mlb.com/bluejays/third-party-footer/" frameborder="0"> </iframe>
    </div>
  </div>
</div>
